import { useEffect, useState } from "react";
import { API } from "aws-amplify";
import * as queries from "../graphql/queries";
import awsconfig from "../aws-exports";
import { Cache } from "aws-amplify";

type IAuthMode =
  | "API_KEY"
  | "AWS_IAM"
  | "OPENID_CONNECT"
  | "AMAZON_COGNITO_USER_POOLS"
  | "AWS_LAMBDA"
  | undefined;

const useLimitLessQuery = <T = any>(
  query: string,
  variables?: object,
  onSuccess?: (data: T) => any,
  isAuto: boolean = true,
  authMode?: IAuthMode
) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState<T>();
  const [error, setError] = useState<any>(null);
  const [refetchFlag, setRefetchFlag] = useState(false);
  const [enabled, setEnabled] = useState(isAuto);
  const refetch = () => {
    setRefetchFlag(!refetchFlag);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      console.log(query + " variables:", variables);
      let nextToken = null;
      let items: T[] = [];

      do {
        const result: any = await API.graphql({
          // @ts-ignore
          query: queries[query],
          variables: {
            ...variables,
            nextToken,
          },
          authMode,
          authToken: awsconfig.aws_appsync_apiKey,
        });

        items = items.concat(result.data[query].items ?? result.data[query]);
        nextToken = result.data[query]?.nextToken;
      } while (nextToken);

      // @ts-ignore
      onSuccess?.(items);
      // @ts-ignore
      setData(items);
      setLoading(false);
    } catch (e) {
      console.log("error", e);
      setError(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (enabled) {
      fetchData();
    } else {
      setEnabled(true);
    }
  }, [refetchFlag]);

  return { error, data, isLoading, refetch };
};

export default useLimitLessQuery;
